import { Helmet } from 'react-helmet-async';

import { CONFIG } from 'src/global-config';

import { ChunkLoadErrorView } from 'src/sections/error';

function ChunkLoadErrorPage() {
  return (
    <>
      <Helmet>
        <title>Update Available | {CONFIG.appName}</title>
      </Helmet>
      <ChunkLoadErrorView />
    </>
  );
}

export default ChunkLoadErrorPage;
